import { useTextColor } from '@/resources/hooks/useTextColor';
import { IAdvantageClub } from '@/store/ducks/settings/types';

export function AdvantageClubPrice({
  backgroundColor,
  color,
  advantage_club,
  biggerCharLimit,
  formatedRewardPrice,
  absoluteDiscount,
  device,
}: {
  backgroundColor: string;
  color: string;
  advantage_club: IAdvantageClub | undefined;
  biggerCharLimit: string;
  formatedRewardPrice: string;
  absoluteDiscount: boolean;
  device: 'mobile' | 'desktop';
}) {
  return (
    <div
      style={{
        lineHeight: 1,
        backgroundColor,
        padding: '0.7rem 0.11rem',
        width: device === 'desktop' ? '11.688rem' : '100%',
        height: '3.5rem',
        borderRadius: '6px',
      }}
      className="reward-price w-lg-50 ml-lg-1 mt-2 mt-lg-0 d-flex flex-column w-sm-50 justify-content-end align-self-end align-items-center pb-0 px-1"
    >
      <div
        className="mb-0 title w-100 d-flex justify-content-center"
        style={{
          color: useTextColor('#fff'),
          backgroundColor: 'white',
          lineHeight: 1,
          fontWeight: 700,
          alignItems: 'flex-end',
          borderRadius: '0.188rem',
          padding: absoluteDiscount ? '0.57rem 0.1rem' : '0.25rem',
          marginRight: absoluteDiscount ? '0.05rem' : '0',
          justifyContent: 'flex-end',
        }}
      >
        <span
          className="text-truncate"
          style={{ maxWidth: absoluteDiscount ? '15ch' : biggerCharLimit }}
        >
          {advantage_club?.text ?? ''}
        </span>
      </div>

      <div
        className="mt-1 py-1 w-100 d-flex justify-content-end"
        style={{ textAlign: 'right', color }}
      >
        <span className="tag">R$ </span>
        <span className="value">{formatedRewardPrice}</span>
      </div>
    </div>
  );
}
